import { StatusPill } from 'pages/Shipments/components/StatusPill/StatusPill';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import { ShippingLine } from './ShippingLine';

interface Props {
  container: Container;
}

export const ContainerTitle: React.FC<Props> = (props) => {
  const { container } = props;

  const title = container.containerType
    ? `${container.containerNumber} · ${container.containerType}`
    : container.containerNumber;

  return (
    <div className="flex space-x-4 items-center">
      <h1 className="font-bold">{title}</h1>
      {container.shipment && <ShippingLine shipment={container.shipment} />}
      <StatusPill status={container.currentStatus} />
    </div>
  );
};
